<template lang="pug">
  SspLayout(area="activator")
    .activator
      .row
        .col-md-12
          ul.wizard
            li(v-for="(step, index) in steps"
              :class="{ active: activeStep==index, passed: index < activeStep}"
              @click="index < activeStep ? activeStep=index : 'do nothing'")
              a
                span {{index + 1}}
              | {{step.title}}
      .loading(v-if="loading") Loading...
      .row(v-else)
        .col-md-12
          component(ref="cmp" :is="steps[activeStep].component"
            @next="next" @prev="prev" @activate="activationSave($event)" @error="$emit('error', $event)")
</template>
<script>
import miniToastr from 'mini-toastr'
import FindRoll from './wiz/FindRoll'
import DefineRange from './wiz/DefineRange'
import AssignProduct from './wiz/AssignProduct'
import AssignMetadata from './wiz/AssignMetadata'
import Activate from './wiz/Activate'
import activationSession from './service/ActivationSession'

export default {
  destroyed() {
    activationSession.clear()
  },
  data: () => ({
    activeStep: 0,
    steps: [{
      title: 'Find roll',
      component: FindRoll
    }, {
      title: 'Define range',
      component: DefineRange
    }, {
      title: 'Assign product',
      component: AssignProduct
    }, {
      title: 'Assign metadata',
      component: AssignMetadata
    }, {
      title: 'Activate',
      component: Activate
    }],
    loading: false
  }),
  methods: {
    next() {
      this.activeStep += 1
    },
    prev() {
      this.activeStep -= 1
    },
    activationSave(data) {
      const firstCode = activationSession.getRollInfo().unassigned.first.code
      const lastCode = activationSession.getTargetInfo().targetCode.code
      this.loading = true
      activationSession
        .activateStrech(firstCode, lastCode, data)
        .then(() => {
          // const orders = resp.data TODO: highlight orders
          this.loading = false
          this.activeStep = 0
          miniToastr.success('Activation successfull')
        })
        .catch((e) => {
          this.$emit('error', e)
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss">
.activator {
  .wizard {
    li {
      display: inline-block;
      padding-right: 25px;
      font-size: 15px;
      line-height: 25px;
      opacity: 0.5;
      margin: 5px 0 10px 0;
      &.active {
        opacity: 1;
      }
    }
    a,
    a:hover {
      cursor: default;
      color: #354052;
    }
    span {
      display: inline-block;
      font-size: 14px;
      font-weight: bold;
      width: 25px;
      height: 25px;
      text-align: center;
      background: #fff;
      border: 1px solid #999;
      border-radius: 100%;
      margin-right: 5px;
    }
    .active span {
      background: #004fe1;
      color: #fff;
      border-color: #004fe1;
    }
    .passed span {
      color: #004fe1;
      border-color: #004fe1;
    }
    .passed {
      cursor: pointer;
      opacity: 1;
      color: #004fe1;
    }
  }

  .clearboth {
    clear: both;
  }

  .v-select .open-indicator {
    right: 14px;
    bottom: 5px;
    &:before {
      width: 9px;
      height: 9px;
      border-color: #555;
      border-width: 1px 1px 0 0;
    }
  }

  .activator {
    .lookup label {
      margin-bottom: 15px;
    }
    .panel {
      border-radius: 4px;
    }
    .smallpadding {
      padding-left: 5px;
      padding-right: 5px;
    }
    .panel-body {
      padding: 34px;
      h2 {
        margin: 0;
        font-size: 24px;
      }
    }
    .form-horizontal {
      clear: both;
    }
    .ssp-data-grid {
      margin: 0 -34px;
      th:first-child,
      td:first-child {
        padding-left: 34px;
        width: 160px;
      }
      th:nth-child(2),
      td:nth-child(2) {
        width: 160px;
      }
      th:last-child,
      td:last-child {
        text-align: right;
        padding-right: 44px;
        width: 180px;
      }
      th,
      td {
        padding: 12px;
        border-width: 0 0 1px 0;
      }
      th {
        padding-top: 17px;
      }
      table {
        border-width: 0;
      }
      .pagination .info {
        display: none;
      }
    }
    h3 {
      font-size: 14px;
      font-weight: bold;
      margin: 0 0 18px 0;
    }
    label.light {
      font-weight: normal;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pages/activator/RollWizard.vue